/*
 * File: AsanaProjectTable.tsx
 * Project: a-a
 * File Created: Tuesday, 29th April 2025 3:06:53 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Thursday, 5th June 2025 11:05:15 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import Paper from '@mui/material/Paper';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import { Box, Chip, LinearProgress, Typography } from '@mui/material';
import formatCurrency from '../../../../helper/short-currency';
import zeplinColor from '../../../../theme/Color';
import { Link } from 'react-router-dom';
import { LightTooltip } from '../../../shared/CustomTooltip/CustomTooltip';
import CustomOverlapImg from '../../../shared/CustomOverlapImg/CustomOverlapImg';
import AsanaProjectTableRow from './AsanaProjectTableRow';
type Response = {
  projectId: string;
  projectName: string;
  updatedDate: string;
  projectLink: string;
  tasksGrouped: { sectionId: string; sectionName: string; tasks: any[] }[];
};
type Projects = {
  Name: string;
  Member: string;
  Teams: string | null;
  Task: string | null;
  Progress: string | null;
};

interface Column {
  id: 'Name' | 'Assignee' | 'Due Date' | 'Priority' | 'Status';
  label: string;
  minWidth?: number;
  maxWidth?: number;
  align?: 'center';
  format?: (value: number) => string;
}

const columns: readonly Column[] = [
  { id: 'Name', label: 'Name', minWidth: 100, maxWidth: 150 },
  { id: 'Assignee', label: 'Assignee' },
  {
    id: 'Due Date',
    label: 'Due Date',

    // align: 'center',
  },
  {
    id: 'Priority',
    label: 'Priority',

    // align: 'center',
  },
  {
    id: 'Status',
    label: 'Status',

    // align: 'center',
  },
];

const AsanaProjectTable = ({
  item,
  loading,
  setModalOpen,
  assignee,
  getTask,
  setDrawerState,
  drawerState,
  filter,
}: {
  item: Response;
  loading: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  assignee: string[];
  getTask: (clear?: boolean) => Promise<void>;
  setDrawerState: React.Dispatch<React.SetStateAction<boolean>>;
  drawerState: boolean;
  filter: boolean;
}) => {
  return (
    <Paper sx={{ width: '100%', border: 'none', boxShadow: 'none' }}>
      <TableContainer
        sx={{
          overflowY: 'auto',
          height: 'calc(100vh - 285px)',
          // paddingBottom: '30rem',
          position: 'relative',
        }}
      >
        <Table stickyHeader aria-label='sticky table' sx={{ position: 'relative' }}>
          {/* <TableHead sx={{ zIndex: 1 }}>
            <TableRow
              sx={{
                border: '1px solid black',
                borderRadius: '14px',
                '& th': {
                  backgroundColor: '#f5f5f5',
                },
                '& th:first-child': {
                  borderRadius: '14px 0px 0px 14px',
                },
                '& th:not(:first-child)': {
                  paddingLeft: '0px',
                },
                '& th:last-child': {
                  borderRadius: '0px 14px 14px 0px',
                },
              }}
            >
              {columns.map((column) => (
                <TableCell key={column.id} align={column.align} sx={{ minWidth: column.minWidth }}>
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead> */}
          <TableHead sx={{ zIndex: 1 }}>
            {filter && item?.tasksGrouped?.filter((val) => val?.tasks?.length)?.length <= 0 ? (
              ''
            ) : (
              <TableRow
                sx={{
                  border: '1px solid black',
                  borderRadius: '14px',
                  '& th': {
                    backgroundColor: '#f5f5f5',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                  },
                  '& th:first-child': {
                    borderRadius: '14px 0px 0px 14px',
                  },
                  '& th:last-child': {
                    borderRadius: '0px 14px 14px 0px',
                  },
                }}
              >
                {columns.map((column) => (
                  <TableCell
                    key={column.id}
                    align={column.align}
                    sx={{
                      minWidth: column.minWidth,
                      maxWidth: column.maxWidth,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            )}
          </TableHead>
          {/* <TableBody
            sx={{ borderCollapse: 'seperate', borderSpacing: '0px 20px', position: 'relative' }}
          > */}
          <AsanaProjectTableRow
            data={item}
            loading={loading}
            setModalOpen={setModalOpen}
            assignee={assignee}
            getTask={getTask}
            drawerState={drawerState}
            setDrawerState={setDrawerState}
            filter={filter}
          />
          {/* </TableBody> */}
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default AsanaProjectTable;
